import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from './common';
import { theme } from '../styles/theme';
import Header from './common/Header';

const FeatureCard = ({ title, description, icon, onClick }) => {
  const cardStyle = {
    background: `linear-gradient(to bottom right, white, ${theme.colors.primary.light})`,
    borderColor: theme.colors.neutral.light
  };

  const iconContainerStyle = {
    background: 'white',
    boxShadow: theme.shadows.md
  };

  const hoverLineStyle = {
    background: `linear-gradient(to right, ${theme.colors.accent.main}, ${theme.colors.accent.hover})`
  };

  return (
    <div onClick={onClick} className="cursor-pointer group">
      <div style={cardStyle} className={`
        relative overflow-hidden rounded-2xl p-8
        transition-all duration-300
        hover:shadow-xl hover:-translate-y-1
        border border-neutral-200
      `}>
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-5">
          <div className="absolute inset-0" style={{ 
            backgroundImage: `radial-gradient(circle at 2px 2px, ${theme.colors.primary.main} 1px, transparent 0)`,
            backgroundSize: '24px 24px'
          }} />
        </div>

        {/* Content */}
        <div className="relative z-10">
          <div className="flex items-start space-x-6 mb-6">
            <div 
              style={iconContainerStyle} 
              className="w-24 h-24 rounded-xl flex items-center justify-center p-2 flex-shrink-0"
            >
              <img src={icon} alt={title} className="w-full h-full object-contain" />
            </div>
            <div>
              <h3 
                style={{ color: theme.colors.text.primary }} 
                className="text-2xl font-bold mb-2"
              >
                {title}
              </h3>
              <p 
                style={{ color: theme.colors.text.secondary }} 
                className="text-lg leading-relaxed"
              >
                {description}
              </p>
            </div>
          </div>
        </div>

        {/* Hover Effect */}
        <div style={hoverLineStyle} className="absolute bottom-0 left-0 right-0 h-1 transform origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-300" />
      </div>
    </div>
  );
};

const SMSPrime = ({ user, setUser }) => {
  const navigate = useNavigate();

  const features = [
    {
      title: 'HIRA Tool',
      description: 'Streamlining Hazard Identification and Risk Assessment for Enhanced Safety and Decision-Making.',
      icon: '/assets/sms-prime/hira-logo.svg',
      path: '/sms-prime/hira'
    }
    // More features will be added here
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header 
        user={user} 
        setUser={setUser}
        title="SMS_Prime"
      />

      <main className="container mx-auto px-4 py-8">
        <div className="max-w-5xl mx-auto">
          <h1 
            className="text-3xl font-bold mb-2" 
            style={{ color: theme.colors.text.primary }}
          >
            Safety Management System
          </h1>
          <p 
            className="text-xl mb-8" 
            style={{ color: theme.colors.text.secondary }}
          >
            Comprehensive tools for managing aviation safety systems and risk assessment
          </p>

          <div className="space-y-6">
            {features.map((feature, index) => (
              <FeatureCard 
                key={index} 
                {...feature} 
                onClick={() => navigate(feature.path)}
              />
            ))}
          </div>
        </div>
      </main>
    </div>
  );
};

export default SMSPrime;
